<script setup>
import axios from '@/../../EshJSLib/services/axios'
import { reactive, ref, onMounted } from "vue";
import { Modal } from "flowbite-vue";

const title = 'Licenze'
const isShowModal = reactive({
  permessi: false,
  funzionalita: false
});


const dataPermessi = ref([])
const recordPermesso = ref([])
const funzionalita = ref([])
const funzionalitaRuolo = ref([])
const idFunzionalitaSel = ref([])

onMounted(async () => {

  axios.get(`/api/security/licenzeList`).then(response => dataPermessi.value = response.data)
    .catch(error => console.log(error));

  axios.get(`/api/security/ruoloList`).then(response => funzionalita.value = response.data)
    .catch(error => console.log(error));

})


function showAddPermessi() {
  recordPermesso.value = {};
  isShowModal.permessi = true;
}



function addPermessi() {

  const ruoli = axios.post(`/api/security/addRuolo`, { data: recordPermesso.value });
  isShowModal.permessi = false;
}

function showAssociaPermessi(id) {
  idFunzionalitaSel.value = id
  funzionalitaRuolo.value = []
  axios.post(`/api/security/ruoloLicenza`, { data: id }).then(response => funzionalitaRuolo.value.push(response.data))
    .catch(error => console.log(error));

  isShowModal.funzionalita = true;

}

function associaFunzionalita() {

  axios.post(`/api/security/addRuoloLicenza`, { data: funzionalitaRuolo.value, id: idFunzionalitaSel.value }).then(response => funzionalitaRuolo.value = [])
    .catch(error => console.log(error));

  isShowModal.funzionalita = false;

}



</script>



<template>
  <h1 class="center">{{ title }}</h1>
  <Modal v-show="isShowModal.permessi" @close="isShowModal.permessi = false;">
    <template #header>
      Aggiungi nuovo {{ title }}
    </template>
    <template #body>
      <div>
        <p> Descrizione </p>
        <input v-model="funzionalita.name" type="text" />
      </div>
      <div class="actionTable">
        <button class="button" @click="isShowModal.permessi = false;">Annulla </button>
        <button class="button" @click="addPermessi">Aggiungi {{ title }}</button>
      </div>
      <table></table>
    </template>
  </Modal>


  <Modal v-show="isShowModal.funzionalita" @close="isShowModal.funzionalita = false;">
    <template #header>
      Associa funzionalita
    </template>
    <template #body>
      <div>
        <v-select v-model="funzionalitaRuolo" label="name" :options="funzionalita" />
      </div>
      <div class="actionTable">
        <button class="button" @click="isShowModal.funzionalita = false;">Annulla </button>
        <button class="button" @click="associaFunzionalita">associa</button>
      </div>
      <table></table>
    </template>
  </Modal>


  <div class="actionTable">
    <button class="button">Cancella {{ title }}</button>
    <button class="button" @click="showAddPermessi">Aggiungi {{ title }}</button>
  </div>


  <table>

    <thead>
      <tr>
        <th></th>
        <th data-type="numeric">ID</th>
        <th data-type="text-short">Descrizione</th>
        <th data-type="text-short">costo</th>
        <th data-type="text-short">enable</th>
        <th data-type="text-short">durata_desc</th>

        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(value, i) in dataPermessi" :key="i">

        <td><input type="checkbox"></td>
        <td>{{ value.id }}</td>
        <td>{{ value.descrizione }}</td>
        <td>{{ value.costo }}</td>
        <td>{{ value.enable }}</td>
        <td>{{ value.durata_desc }}</td>

        <td><button class="button_small" @click="showAssociaPermessi(value.id)">Associa Ruolo</button>
        </td>

      </tr>
    </tbody>
  </table>

</template>


<style scoped>
* {
  box-sizing: border-box;
}

.actionTable {
  display: flex;
  justify-content: flex-end;
  margin: 10px;
}

.button {
  background-color: #04AA6D;
  /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 10px;

}

.button_small {
  background-color: #04AA6D;
  /* Green */
  border: none;
  color: white;
  padding: 5px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;


}

.center {
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  border: 3px solid green;
  margin-top: 10px;
  margin-bottom: 10px;
}

html,
body {
  padding: 0;
  margin: 0;
}

body {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

table {
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns:
    minmax(150px, 1fr) minmax(150px, 1.67fr) minmax(150px, 1.67fr) minmax(150px, 1.67fr) minmax(150px, 1.67fr) minmax(150px, 1.67fr) minmax(150px, 1.67fr);
}

thead,
tbody,
tr {
  display: contents;
}

th,
td {
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

th {
  position: sticky;
  top: 0;
  background: #1A576E;
  text-align: left;
  font-weight: normal;
  font-size: 1.1rem;
  color: white;
}

th:last-child {
  border: 0;
}

td {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #808080;
}

tr:nth-child(even) td {
  background: #f8f6ff;
}
</style>